import { ChangeDetectionStrategy, Component, computed, viewChild } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, MbsSize, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { RoutingPath } from 'mbs-ui-shared@constants';

@Component({
  selector: 'mbs-tfa-require-modal',
  templateUrl: './tfa-require-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective, RouterLink, RouterModule]
})
export class TFARequireModalComponent {
  protected readonly MbsSize = MbsSize;
  protected readonly RoutingPath = RoutingPath;

  protected readonly baseModal = viewChild(ModalComponent);

  protected readonly actionName = computed<string>(() => this.baseModal()?.data?.actionName);
  protected readonly isVerb = computed<boolean>(() => this.baseModal()?.data?.isVerb ?? false);

  handleClose(): void {
    this.baseModal().close();
  }
}
